<div class="row">
	<div class="text-end ml-1">
		<label>
			{{ placeHolder + ' :' }}
		</label>
	</div>
	<div class="input-group ml-1">
		<input
			#name
			[placeholder]="placeHolder"
			[type]="inputTypeUsed"
			[formControl]="control"
			class="form-control"
			[ngClass]="{ 'is-invalid': showError() }"
			autocomplete="new-password"
			*ngIf="!model"
			aria-describedby="eye"
		/>
		<input
			[(ngModel)]="model"
			[type]="inputTypeUsed"
			[formControl]="control"
			class="form-control"
			[ngClass]="{ 'is-invalid': showError() }"
			autocomplete="new-password"
			*ngIf="model"
			aria-describedby="eye"
		/>
		<div
			class="input-group-text"
			(click)="togglePasswordToText()"
			*ngIf="inputType === 'password'"
		>
			<span class="">
				<i
					id="eye"
					class="bi"
					[ngClass]="{
						'bi-eye-slash': !togglePassword,
						'bi-eye': togglePassword
					}"
					aria-hidden="true"
				></i>
			</span>
		</div>
	</div>
</div>

<div *ngIf="showError()" class="text-danger mt-1">
	<small>
		<p *ngIf="control.errors.required">{{ placeHolder }} est requis</p>
		<p *ngIf="control.errors.minlength">
			Vous avez entré
			{{ control.errors.minlength.actualLength }} caractères mais au moins
			{{ control.errors.minlength.requiredLength }} sont requis.
		</p>
		<p *ngIf="control.errors.maxlength">
			Vous avez entré
			{{ control.errors.maxlength.actualLength }} caractères mais un maximum de
			{{ control.errors.maxlength.requiredLength }} est requis.
		</p>
		<p *ngIf="control.errors.pattern">
			{{ errorPattern }}
		</p>
		<p *ngIf="control.errors.email">L'adresse email n'est pas valide</p>
	</small>
</div>
<br />
